module.exports = __webpack_public_path__ + "media/images/area/feature/kansai/related/th/5-045e5dccfb7d27a7a9cd8cb44c5d4f61.jpg";